import { FC } from "react";
import cx from "classnames";
import { Form, Formik } from "formik";
import { useTranslation } from "i18n";
import { AgenciesWithFilmmakers } from "component-library/src/components/Organisms/AppShell/navigation/helpers/getNavHeaderLinks";
import { Button, RadioFormik } from "component-library";
import { dataTestIds } from "data-testids";
import "./SeveralAgenciesWithMultipleFilmmakers.scss";

const AGENCY_REF_NUMBER = "agencyRefNumber";
interface Props {
  handleClose: () => void;
  handleSubmit: (agencyRefNumber: number) => Promise<void>;
  agenciesWithFilmmakers: AgenciesWithFilmmakers[];
  isError: boolean;
}

const SeveralAgenciesWithMultipleFilmmakers: FC<
  React.PropsWithChildren<Props>
> = ({ handleClose, handleSubmit, agenciesWithFilmmakers, isError }) => {
  const { t } = useTranslation();

  return (
    <Formik
      initialValues={{
        [AGENCY_REF_NUMBER]: undefined,
      }}
      onSubmit={async (values) => {
        if (values.agencyRefNumber) {
          await handleSubmit(values.agencyRefNumber);
        }
      }}
    >
      {({ values, submitForm, isSubmitting }) => {
        return (
          <>
            <div className="border-b border-grey-light-2 pt-[10px] pr-[15px] pb-[8px] pl-[15px]">
              <h3 className="text-[22px] leading-[30px] font-medium">
                {t("common:label.severalAgenciesWithMultipleFilmmakers.title")}
              </h3>
            </div>

            <div className="pt-[10px] pr-[15px] pb-[10px] pl-[15px] break-words overflow-hidden">
              <p className="flex flex-col gap-1 lg:flex-row">
                {t("common:label.severalAgenciesWithMultipleFilmmakers.info")}
              </p>

              <Form>
                <div className="my-[10px] mb-[23px] flex flex-col gap-[15px]">
                  {agenciesWithFilmmakers.map((item) => {
                    return (
                      <div
                        className="flex items-center justify-start gap-[14px]"
                        key={`key-${item.AgencyRefNumber}`}
                      >
                        <RadioFormik
                          name={AGENCY_REF_NUMBER}
                          value={item.AgencyRefNumber}
                          label={item.AgencyName}
                          className={cx(
                            "text-base cursor-pointer select-none",
                            {
                              "font-bold":
                                Number(values.agencyRefNumber) ===
                                item.AgencyRefNumber,
                            }
                          )}
                          white
                        />
                      </div>
                    );
                  })}
                </div>
              </Form>
            </div>

            <div className="flex flex-col-reverse gap-[10px] lg:flex-row lg:justify-between border-t border-grey-light-2 pt-[15px] pr-[15px] pb-[10px] pl-[15px]">
              <div>
                <Button
                  type="secondary"
                  text={t(
                    "common:button.severalAgenciesWithMultipleFilmmakers.cancel"
                  )}
                  size="medium"
                  onClick={handleClose}
                />
              </div>
              <div>
                <Button
                  type="primary"
                  text={t(
                    "common:button.severalAgenciesWithMultipleFilmmakers.logIn"
                  )}
                  size="medium"
                  onClick={submitForm}
                  disabled={!values.agencyRefNumber}
                  loading={isSubmitting || isError}
                  iconName="icon-open-in-new-tab"
                  data-testid={
                    dataTestIds.componentLibrary[
                      "Organisms.AgenciesWithFilmmakersPopUp.SeveralAgenciesWithMultipleFilmmakers.cancleButton"
                    ]
                  }
                />
              </div>
            </div>
          </>
        );
      }}
    </Formik>
  );
};

export default SeveralAgenciesWithMultipleFilmmakers;
